(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-brush-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sm-brush-offer]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const applyCard = (card) => {
      const variantId = String(card.dataset.variantId || '');
      const title = card.dataset.variantTitle || '';
      const price = card.dataset.price || '';
      root.querySelectorAll('.sm-brush-offer__deal').forEach((el) => {
        el.classList.toggle('is-on', el.dataset.variantId === variantId);
      });
      document.querySelectorAll('variant-picker input[type="radio"]').forEach((input) => {
        if (input.value === title || input.getAttribute('aria-label') === title) {
          if (!input.checked) input.click();
        }
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.querySelectorAll('.add-to-cart-button .price-now').forEach((el) => {
        if (price) el.textContent = price;
      });
    };

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-variant-id]');
      if (!card) return;
      event.preventDefault();
      applyCard(card);
    });

    const on = root.querySelector('.sm-brush-offer__deal.is-on') || root.querySelector('.sm-brush-offer__deal.is-pop');
    if (on) applyCard(on);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-foam-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sm-foam-offer]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const viewing = root.querySelector('[data-sm-foam-viewing]');
    if (viewing) {
      const n = 8 + Math.floor(Math.random() * 14);
      viewing.textContent = `${n} customers are viewing this product right now`;
    }

    const applyCard = (card) => {
      const variantId = String(card.dataset.variantId || '');
      const title = card.dataset.variantTitle || '';
      const price = card.dataset.price || '';
      const compare = card.dataset.compare || '';
      document.querySelectorAll('[data-sm-foam-deals] .sm-foam-offer__deal').forEach((el) => {
        el.classList.toggle('is-on', el.dataset.variantId === variantId);
      });
      document.querySelectorAll('variant-picker input[type="radio"]').forEach((input) => {
        if (input.value === title || input.getAttribute('aria-label') === title) {
          if (!input.checked) input.click();
        }
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.querySelectorAll('.add-to-cart-button .price-now').forEach((el) => {
        if (price) el.textContent = price;
      });
      document.querySelectorAll('.add-to-cart-button .price-old').forEach((el) => {
        if (compare && compare !== price) {
          el.textContent = compare;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    };

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-variant-id]');
      if (!card) return;
      event.preventDefault();
      applyCard(card);
    });

    const on = root.querySelector('.sm-foam-offer__deal.is-on') || root.querySelector('.sm-foam-offer__deal.is-pop');
    if (on) applyCard(on);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-goda-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sm-mask-offer]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const viewing = root.querySelector('[data-sm-foam-viewing]');
    if (viewing) {
      const n = 8 + Math.floor(Math.random() * 14);
      viewing.textContent = `${n} customers are viewing this product right now`;
    }

    const applyCard = (card) => {
      const variantId = String(card.dataset.variantId || '');
      const title = card.dataset.variantTitle || '';
      const price = card.dataset.price || '';
      const compare = card.dataset.compare || '';
      document.querySelectorAll('[data-sm-mask-deals] .sm-foam-offer__deal').forEach((el) => {
        el.classList.toggle('is-on', el.dataset.variantId === variantId);
      });
      document.querySelectorAll('variant-picker input[type="radio"]').forEach((input) => {
        if (input.value === title || input.getAttribute('aria-label') === title) {
          if (!input.checked) input.click();
        }
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.querySelectorAll('.add-to-cart-button .price-now').forEach((el) => {
        if (price) el.textContent = price;
      });
      document.querySelectorAll('.add-to-cart-button .price-old').forEach((el) => {
        if (compare && compare !== price) {
          el.textContent = compare;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    };

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-variant-id]');
      if (!card) return;
      event.preventDefault();
      applyCard(card);
    });

    const on = root.querySelector('.sm-foam-offer__deal.is-on') || root.querySelector('.sm-foam-offer__deal.is-pop');
    if (on) applyCard(on);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-hm-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__smHmOffer) return;
    window.__smHmOffer = true;
    const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const arrive = () => {
      document.querySelectorAll('[data-sm-hm-arrive]').forEach((el) => {
        const a = new Date(); a.setDate(a.getDate() + 5);
        const b = new Date(); b.setDate(b.getDate() + 10);
        el.innerHTML = 'Order today, arrives <b>' + fmt(a) + ' – ' + fmt(b) + '</b>';
      });
    };
    const apply = (bar) => {
      const id = String(bar.dataset.variantId || '');
      const title = bar.dataset.variantTitle || '';
      const price = bar.dataset.price || '';
      const compare = bar.dataset.compare || '';
      const save = bar.dataset.save || '';
      document.querySelectorAll('[data-sm-hm-offer] .sm-hm__bar').forEach((el) => {
        const on = el.dataset.variantId === id;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      document.querySelectorAll('variant-picker input[type="radio"]').forEach((input) => {
        if ((input.dataset.variantId === id || input.value === title) && !input.checked) input.click();
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        if (input.closest('[data-sm-addon]')) return;
        input.value = id;
      });
      document.querySelectorAll('.add-to-cart-button .price-now').forEach((el) => { if (price) el.textContent = price; });
      document.querySelectorAll('.add-to-cart-button .price-old').forEach((el) => {
        if (compare && compare !== price) { el.textContent = compare; el.hidden = false; } else { el.textContent = ''; el.hidden = true; }
      });
      document.querySelectorAll('[data-sm-hm-save]').forEach((el) => { if (save) el.textContent = save; });
      document.querySelectorAll('[data-sm-hm-now]').forEach((el) => { if (price) el.textContent = price; });
      document.querySelectorAll('[data-sm-hm-was]').forEach((el) => { if (compare) el.textContent = compare; });
    };
    document.addEventListener('click', (event) => {
      const bar = event.target.closest('[data-sm-hm-offer] .sm-hm__bar');
      if (!bar) return;
      event.preventDefault();
      apply(bar);
    });
    arrive();
    document.addEventListener('DOMContentLoaded', arrive);
    new MutationObserver(() => {
      if (document.querySelector('[data-sm-hm-arrive]:not(:has(b))')) arrive();
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-launch-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sm-midnight-countdown')) {
    customElements.define('sm-midnight-countdown', class extends HTMLElement {
      connectedCallback() {
        this.tick = () => {
          const now = new Date();
          const midnight = new Date(now);
          midnight.setHours(24, 0, 0, 0);
          const seconds = Math.max(0, Math.floor((midnight - now) / 1000));
          const values = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
          this.querySelector('[data-countdown]').textContent = values.map(value => String(value).padStart(2, '0')).join(':');
        };
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-mask-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sm-mask-offer]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const viewing = root.querySelector('[data-sm-foam-viewing]');
    if (viewing) {
      const n = 8 + Math.floor(Math.random() * 14);
      viewing.textContent = `${n} customers are viewing this product right now`;
    }

    const applyCard = (card) => {
      const variantId = String(card.dataset.variantId || '');
      const title = card.dataset.variantTitle || '';
      const price = card.dataset.price || '';
      const compare = card.dataset.compare || '';
      document.querySelectorAll('[data-sm-mask-deals] .sm-foam-offer__deal').forEach((el) => {
        el.classList.toggle('is-on', el.dataset.variantId === variantId);
      });
      document.querySelectorAll('variant-picker input[type="radio"]').forEach((input) => {
        if (input.value === title || input.getAttribute('aria-label') === title) {
          if (!input.checked) input.click();
        }
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.querySelectorAll('.add-to-cart-button .price-now').forEach((el) => {
        if (price) el.textContent = price;
      });
      document.querySelectorAll('.add-to-cart-button .price-old').forEach((el) => {
        if (compare && compare !== price) {
          el.textContent = compare;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    };

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-variant-id]');
      if (!card) return;
      event.preventDefault();
      applyCard(card);
    });

    const on = root.querySelector('.sm-foam-offer__deal.is-on') || root.querySelector('.sm-foam-offer__deal.is-pop');
    if (on) applyCard(on);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-soap-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sm-soap-offer]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const viewing = root.querySelector('[data-sm-soap-viewing]');
    if (viewing) {
      const n = 8 + Math.floor(Math.random() * 14);
      viewing.textContent = `${n} customers are viewing this product right now`;
    }

    const applyCard = (card) => {
      const variantId = String(card.dataset.variantId || '');
      const title = card.dataset.variantTitle || '';
      const price = card.dataset.price || '';
      const compare = card.dataset.compare || '';
      document.querySelectorAll('[data-sm-soap-deals] .sm-soap-offer__deal').forEach((el) => {
        el.classList.toggle('is-on', el.dataset.variantId === variantId);
      });
      document.querySelectorAll('variant-picker input[type="radio"]').forEach((input) => {
        if (input.value === title || input.getAttribute('aria-label') === title) {
          if (!input.checked) input.click();
        }
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.querySelectorAll('.add-to-cart-button .price-now').forEach((el) => {
        if (price) el.textContent = price;
      });
      document.querySelectorAll('.add-to-cart-button .price-old').forEach((el) => {
        if (compare && compare !== price) {
          el.textContent = compare;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    };

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-variant-id]');
      if (!card) return;
      event.preventDefault();
      applyCard(card);
    });

    const on = root.querySelector('.sm-soap-offer__deal.is-on') || root.querySelector('.sm-soap-offer__deal.is-pop');
    if (on) applyCard(on);
  })();
  } catch(e) { console.error(e); }
})();

})();
